import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LogoTaf from '../images/logo-taf.png';
import wefoxLogo from '../images/wefox.png';
import DHMRLogo from '../images/dhmrLogo.png';
import { isBrand } from '../utils/utils';
import Brand from '../enums/Brand';

import './loading.css';

export const Loader: React.FC = () => (
  <div className="loading-wrapper">
    <FontAwesomeIcon icon="circle-notch" spin={true} size="10x" />
  </div>
);

const Loading: React.FC = () => {

  const isWefox = isBrand(Brand.wefox);
  const isDHMR = isBrand(Brand.DHMR);

  let logo = LogoTaf;

  if (isWefox) {
    logo = wefoxLogo;
  } else if (isDHMR) {
    logo = DHMRLogo;
  }

  return (
    <div className="App">
      <div className="App-navigation" />

      <div className="App-header">
        <div className="logo">
          <img src={logo} alt="Company logo" />
        </div>
      </div>

      <div className="App-content">
        <Loader />
      </div>
    </div>
  );
};

export default Loading;
